
<div
	class="env-card-container"
	:tabindex="tabindex"
	:newEnv="newEnv"
	:compact="compact"
	@click="handleClick($event)"
>
	<div v-if="!newEnv" class="env-card-state" :state="state" :compact="compact" />
	<div v-if="!compact && !newEnv" class="env-card-info">
		<slot />
	</div>
	<div v-if="newEnv" class="env-card-new" :compact="compact">
		<div class="env-plus-container">
			<Icon name="i-plus" state="dark" :effects="false" size="x-small" />
		</div>
		<p v-if="!compact" class="paragraph-2 fc-dark">New environment</p>
	</div>
</div>
